var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-bg-primary s-text-black s-text-center s-p-5 s-hero"
  }, [_c('p', {
    staticClass: "s-font-semibold"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }